// extracted by mini-css-extract-plugin
export var copyableItem = "_9-0";
export var underlined = "_9-1";